




























import DetachableHeader from 'vue-detachable-header'
import 'vue-detachable-header/index.css'
import Logo from 'library/components/globals/logo'
import DesktopNav from './desktop-nav'
import UtilityLinks from './utility-links'
import CartTrigger from './cart-trigger'
import TabbedNav from '../tabbed-nav'
import Banner from '../banner/banner'
import HeaderHeightMixin from 'library/mixins/header-height'
import { disableBodyScroll } from 'body-scroll-lock'

export default

	mixins: [ HeaderHeightMixin ]

	components: {
		DetachableHeader
		Logo
		DesktopNav
		UtilityLinks
		CartTrigger
		TabbedNav
		Banner
	}

